/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'deviantart': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#00ce3e" d="M0 0v32h32V0H0zm23.529 8.058l-4.636 9.179h4.636v6.395h-7.865l-2.448 4.847H8.471v-4.185l4.762-9.429H8.471V8.47h7.991l2.5-4.95h4.567v4.538z"/>'
  }
})
